import React, { useState, useEffect } from "react";
import { Modal, Button, Table, IconButton } from "@deere/ux.uxframe-react";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";
import Select from "react-select";
import { ERR_EXISTING_COUNTRY, ERR_SELECT_OPTION } from "../../utils/errorLiterals";
import { useTranslation } from "react-i18next";

const ModalAddCountry = ({ showModal, setShowModal, rowToUpdateCountry, countryList, saveHandler, isSelfService }) => {
  const [partCountries, setPartCountries] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [newInput, setNewInput] = useState(null);
  const [error, setError] = useState("");
  const { t } = useTranslation();
  const customStyles = {
    menu: (base) => ({ ...base, position: "relative" }),
    dropdownIndicator: (base) => ({ ...base, height: 35, minHeight: 35 }),
    valueContainer: (base) => ({ ...base, height: 35, minHeight: 35 }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      return { ...provided, opacity };
    },
  };

  useEffect(() => {
    if (rowToUpdateCountry && rowToUpdateCountry.country) setPartCountries(rowToUpdateCountry.country);
  }, [rowToUpdateCountry]);

  useEffect(() => {
    if (countryList && countryList.length > 0) {
      let tempArr = [];
      countryList.forEach((country) => {
        let obj = { label: country.name, value: country.name };
        tempArr.push(obj);
      });
      setCountryOptions(tempArr);
    }
  }, [countryList]);

  const changeHandler = (event) => {
    setNewInput(event);
    setError("");
  };

  const addHandler = () => {
    if (newInput) {
      const index = partCountries.indexOf(newInput.value);
      if (index > -1) setError(ERR_EXISTING_COUNTRY);
      else {
        setPartCountries((prevState) => {
          return [...prevState, newInput.value];
        });
        setNewInput(null);
        setError("");
      }
    } else setError(ERR_SELECT_OPTION);
  };

  const deleteHandler = (item) => {
    let tempArr = [...partCountries];
    const index = tempArr.indexOf(item);
    if (index > -1) tempArr.splice(index, 1);
    setPartCountries(tempArr);
  };

  const closeModal = () => {
    setPartCountries(rowToUpdateCountry.country);
    setError("");
    setNewInput(null);
    setShowModal(false);
  };

  return (
    <Modal show={showModal} backdrop="static">
      <Modal.Header>
        <div>
          <h3>{isSelfService?t("self_service_popup_header"):t("coo_popup_header")}</h3>
          <p style={{ marginBottom: "0" }}>{t("coo_popup_subheader")}</p>
        </div>
      </Modal.Header>
      <Modal.Body className="overflow-scroll">
        <Table>
          <tbody>
            {partCountries.map((data) => {
              return (
                <tr key={data}>
                  <td>{data}</td>
                  <td>
                    <IconButton ariaLabel={t("btn_delete")} onClick={() => deleteHandler(data)}>
                      <DeleteIcon />
                    </IconButton>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <div style={{ width: "80%" }}>
            <Select
              cacheOptions={true}
              defaultOptions
              options={countryOptions}
              value={newInput}
              isClearable={true}
              styles={customStyles}
              noOptionsMessage={() => "Start Typing..."}
              onChange={changeHandler}
            />
          </div>
          <div className="max-h-10">
            <Button variant="secondary" onClick={addHandler} disabled={countryOptions.length === 0}>
            {t("btn_add")}
            </Button>
          </div>
        </div>
        {error !== "" && <div style={{ color: "red", fontSize: "smaller" }}>{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          {t("btn_cancel")}
        </Button>
        <Button
          type="submit"
          variant="primary"
          onClick={() => {
            saveHandler(rowToUpdateCountry.id, partCountries);
            setError("");
            setNewInput(null);
            setShowModal(false);
          }}
          disabled={isSelfService ? true : false}
        >
          {t("btn_save_survey")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddCountry;
